import { ProductWarrantyClaimStatus } from '@cbgms/api'
import makeStyles from '@mui/styles/makeStyles'

const blueColor = '#0288D1'
const redColor = '#ED6C02'
const greenColor = '#2E7D32'
const blackColor = '#4B4B4B'

export const warrantyClasses = makeStyles(() => ({
  buleFont: {
    color: blueColor
  },
  redFont: {
    color: redColor
  },
  greenFont: {
    color: greenColor
  },
  blackFont: {
    color: blackColor
  },
  boldFont: {
    fontWeight: 'bold'
  }
}))

export const getWarrantyClaimStatusColorCode = (status: string): string => {
  switch (status.toLowerCase()) {
    case ProductWarrantyClaimStatus.Sent.toLowerCase():
      return blueColor
    case ProductWarrantyClaimStatus.InProgress.toLowerCase():
      return redColor
    case ProductWarrantyClaimStatus.Finalised.toLowerCase():
      return greenColor
    case ProductWarrantyClaimStatus.Rejected.toLowerCase():
      return blackColor
    default:
      return blackColor
  }
}
